// Port dla konceptu "żywy" (t_3d96c476) z store-integration/preview/assets/cart/pdp-buybar.js
// t_bcb65f62: przypięty pasek zakupu na PDP (desktop i mobile).
// Pokazuje się, gdy oryginalne „Dodaj do torby” / „Zapłać” (.pdp-purchase) są poza widokiem,
// chowa się, gdy widać stopkę. Przyciski paska klikają oryginały, więc logika koszyka zostaje w pdp-cart.js.
// Pasek przejmuje też rolę mobilnego .pdp-wz-dock (status kroku, klik przewija do konfiguracji).
(() => {
  'use strict';
  const root = document.querySelector('.pdp-page[data-product-page]');
  if (!root || root.dataset.native === 'true' || root.querySelector('[data-buybar]')) return;
  const add = root.querySelector('[data-add]');
  const pay = root.querySelector('[data-pay]');
  const purchase = root.querySelector('.pdp-purchase') || add;
  if (!add || !purchase) return;
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };

  const bar = el('div', 'pdp-buybar'); bar.dataset.buybar = ''; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Zakup');
  bar.hidden = true;
  const inner = el('div', 'pdp-buybar-inner');
  const info = el('button', 'pdp-buybar-info'); info.type = 'button';
  const name = el('span', 'pdp-buybar-name');
  const status = el('span', 'pdp-buybar-status'); status.setAttribute('aria-live', 'polite');
  info.append(name, status);
  const actions = el('div', 'pdp-buybar-actions');
  const bAdd = el('button', 'pdp-buybar-add', 'Dodaj do torby'); bAdd.type = 'button'; bAdd.dataset.buybarAdd = '';
  actions.append(bAdd);
  let bPay = null;
  if (pay) { bPay = el('button', 'pdp-buybar-pay', 'Zapłać'); bPay.type = 'button'; bPay.dataset.buybarPay = ''; actions.append(bPay); }
  inner.append(info, actions); bar.append(inner);
  root.append(bar);
  root.classList.add('has-buybar');

  const title = () => (root.querySelector('h1[data-product-title]') || {}).textContent || '';
  const price = () => { const p = root.querySelector('[data-price]'); return p && !p.hidden ? p.textContent.trim() : ''; };
  let flash = '', flashTimer = 0;
  function stepText() {
    const w = window.ALTIVEST_PDP_WIZARD; const d = root.dataset;
    if (!w || !d.wizardStep) return '';
    const done = Number(d.wizardDone || 0);
    const total = Number(d.wizardTotal || 4); const pos = Math.max(1, [...root.querySelectorAll('[data-wz-step]:not([hidden])')].findIndex((s) => s.dataset.wzStep === d.wizardStep) + 1);
    return done >= total ? 'Gotowe do torby' : 'Krok ' + pos + ' z ' + total;
  }
  const setText = (n, t) => { if (n.textContent !== t) n.textContent = t; };
  function paint() {
    setText(name, [title().trim(), price()].filter(Boolean).join(', '));
    setText(status, flash || stepText());
    if (bAdd.disabled !== add.disabled) bAdd.disabled = add.disabled;
    const added = add.classList.contains('is-added');
    bAdd.classList.toggle('is-added', added);
    setText(bAdd, added ? add.textContent : 'Dodaj do torby');
  }

  // Oryginały są w formularzu konfiguracji; klik w oryginał uruchamia ten sam submit/walidację co zwykle.
  bAdd.addEventListener('click', () => { add.click(); paint(); });
  if (bPay) bPay.addEventListener('click', () => pay.click());
  info.addEventListener('click', () => {
    const panel = root.querySelector('.pdp-panel') || purchase;
    panel.scrollIntoView({ behavior: reduce() ? 'instant' : 'smooth', block: 'start' });
  });

  // Komunikat z pdp-cart.js (dodano / czego brakuje) pokazujemy też w pasku, bo oryginał może być poza ekranem.
  // Obserwujemy wyłącznie ten komunikat (pasek leży w root, szerszy obserwator zapętliłby się na własnych zmianach).
  const noteBox = root.querySelector('[data-cart-added]');
  if (noteBox) new MutationObserver(() => {
    const n = noteBox.querySelector('p'); if (!n || !n.textContent || bar.hidden) return;
    flash = n.textContent; clearTimeout(flashTimer); flashTimer = setTimeout(() => { flash = ''; paint(); }, 2600); paint();
  }).observe(noteBox, { subtree: true, childList: true, characterData: true });
  new MutationObserver(paint).observe(root, { attributes: true, attributeFilter: ['data-wizard-step', 'data-wizard-done', 'data-cart-ready'] });
  new MutationObserver(paint).observe(add, { attributes: true, attributeFilter: ['class', 'disabled'] });

  // Widoczność: oryginał poza ekranem i stopka niewidoczna.
  let purchaseVisible = true, footerVisible = false;
  const footer = document.querySelector('footer');
  function sync() {
    const show = !purchaseVisible && !footerVisible && !document.querySelector('dialog[open]');
    if (bar.hidden === !show) return;
    bar.hidden = !show;
    document.documentElement.classList.toggle('buybar-open', show);
    if (show) paint();
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((es) => { purchaseVisible = es.some((x) => x.isIntersecting); sync(); }, { threshold: 0.6 }).observe(purchase);
    if (footer) new IntersectionObserver((es) => { footerVisible = es.some((x) => x.isIntersecting); sync(); }, { threshold: 0 }).observe(footer);
  }
  document.addEventListener('toggle', sync, true);
  document.addEventListener('close', sync, true);
  paint();
  window.ALTIVEST_PDP_BUYBAR = { bar, sync, paint };
})();
